var _defs, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 29 28.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8e97cd;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #c0c9ff;\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -1.5,
    y: -1.75,
    width: 32,
    height: 32,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_204_3463",
    "data-name": "mask0 204 3463"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1.5,
    y: -1.75,
    width: 32,
    height: 32
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.75,
    y: 10.36,
    width: 12.97,
    height: 17.64,
    rx: 2.36,
    ry: 2.36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.28,
    y: 0.5,
    width: 12.97,
    height: 17.64,
    rx: 2.36,
    ry: 2.36
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.22,
    y: -1.96,
    width: 8.04,
    height: 12.97,
    rx: 1.46,
    ry: 1.46,
    transform: "translate(2.72 11.76) rotate(-90)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.75,
    y: 17.49,
    width: 8.04,
    height: 12.97,
    rx: 1.46,
    ry: 1.46,
    transform: "translate(-2.21 45.75) rotate(-90)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.1fedd87c33a0ca1ebe5c22311e083b63.svg";
export { ForwardRef as ReactComponent };